import { ReloadOutlined } from '@ant-design/icons';
import { Button, Card, Carousel, Col, Divider, Form, Grid, Input, InputNumber, notification, Popconfirm, Row, Select, Spin, Switch } from 'antd';
import * as Api from 'api';
import DashboardImageCard from 'components/activity/dashboardImageCard';
import CameraAddMap from 'components/camera/cameraAddMap';
import { CameraPinType } from 'helpers/types';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useAuth from 'redux/auth/auth.hook';
import { PATHS } from 'res/routes';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};

const buttonLayout = {
  wrapperCol: {
    span: 24,
  },
};

interface ParamTypes {
  camera_id: string
}
const CameraEdit = () => {
  const { camera_id } = useParams<ParamTypes>();

  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const { md } = useBreakpoint();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [cameras, setCameras] = useState<CameraPinType[]>([]);
  const [loadingRecently, setLoadingRecently] = useState(false);
  const [timezones, setTimezones] = useState([]);

  const { auth: { profile } } = useAuth();
  const [camera, setCamera] = useState<any>({
    id: 0,
    name: '',
    IMEI: '',
    IMEI_suspended: '',
    timezone: '',
    latitude: 30.684755,
    longitude: -90.969077,
    type: 'Camera',
    fix_location: 0,
    is_active: 0,
  });
  const [images, setImages] = useState<any>([]);

  useEffect(() => {
    if (camera_id) {
      httpGetTimezones();
      loadData();
      loadRecentlyImages();
      httpGetCameras();
    }
  }, [camera_id]);

  const loadData = () => {
    setLoading(true);
    Api.CAMERA_GET_ONE(camera_id).then(((res: any) => {
      const result = JSON.parse(res.text);
      console.log(result);
      setCamera(result.camera);
      form.setFieldsValue(result.camera);
      setLoading(false);
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const httpGetCameras = () => {
    setLoading(true);
    Api.CAMERA_GET_LIVE_ALL().then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      setCameras(result.data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const httpGetTimezones = () => {
    Api.MAP_GET_TIMEZONES().then(((res: any) => {
      const result = JSON.parse(res.text);
      setTimezones(result.data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const loadRecentlyImages = () => {
    if (profile) {
      // get cameras and tags
      setLoadingRecently(true);
      Api.CAMERA_RECENTLY_IMAGES(camera_id).then((res: any) => {
        const result = JSON.parse(res.text);
        console.log(result);
        setImages(result.images);
        setLoadingRecently(false);
      });
    }
  };

  const onValuesChange = (values, allvalues) => {
    console.log(allvalues);
    const newCamera = { ...camera, ...allvalues };
    setCamera(newCamera);
  };

  const onFinish = (values) => {
    const params = {
      user_id: profile.user_id,
      name: camera.name,
      id: camera.id,
      timezone: camera.timezone,
      latitude: camera.latitude,
      longitude: camera.longitude,
      IMEI: camera.IMEI,
      fix_location: camera.fix_location,
    };
    Api.CAMERA_EDIT(params).then(((res: any) => {
      const data = JSON.parse(res.text);
      if (data.result == 'ok') {
        const path = PATHS.CAMERA;
        history.push(path);
      } else {
        notification.open({
          message: data.msg,
        });
      }
      // setForecastdata(data.data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onFinishAssign = (values) => {
    const params = {
      IMEI: values.IMEI,
      camera_id: camera.id,
    };
    Api.CAMERA_ASSIGN(params).then(((res: any) => {
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        const path = PATHS.CAMERA;
        history.push(path);
      } else {
        notification.open({
          message: data.message,
        });
      }
      // setForecastdata(data.data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onDragEnd = (evt) => {
    const { latLng } = evt;
    // updateMarkerPositionTxt(latLng);

    const newCamera = {
      ...camera,
      ...{
        latitude: Number(latLng.lat().toFixed(6)),
        longitude: Number(latLng.lng().toFixed(6)),
      },
    };
    setCamera(newCamera);
    form.setFieldsValue(newCamera);
  };

  const deleteItem = () => {
    if (window.confirm('Are you sure you want to delete this camera?')) {
      Api.CAMERA_DELETE(camera_id).then((res) => {
        console.log('delete camera', res);
        history.goBack();
      }).catch((error: any) => {
        console.log('error ===>', error);
      });
    }
  };

  const onChangeFixLocation = (checked) => {
    console.log(`switch to ${checked}`);
    const newCamera = {
      ...camera,
      ...{
        fix_location: checked ? 1 : 0,
      },
    };
    setCamera(newCamera);
    form.setFieldsValue(newCamera);
  };
  const onTrashAll = () => {
    const params = {
      camera_id: camera.id,
    };
    Api.CAMERA_TRASH_ALL(params).then(((res: any) => {
      notification.open({
        message: res.text,
      });
      loadRecentlyImages();
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onArchive = () => {
    const params = {
      camera_id: camera.id,
    };
    Api.CAMERA_ARCHIVE(params).then(((res: any) => {
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        const path = PATHS.CAMERA;
        history.push(path);
      } else {
        notification.open({
          message: data.message,
        });
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onChangeActivate = (checked) => {
    console.log('error ===>', checked);
    const params = {
      IMEI: camera.IMEI,
      is_active: checked ? 1 : 0,
    };
    setLoading(true);
    Api.CAMERA_ACTIVATE(params).then(((res: any) => {
      setLoading(false);
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        loadData();
      } else {
        notification.open({
          message: data.message,
        });
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const changeCamera = (value) => {
    console.log(`selected ${value}`);
    const newCamera = {
      ...camera,
      ...{
        latitude: cameras[value].latitude,
        longitude: cameras[value].longitude,
      },
    };
    setCamera(newCamera);
    form.setFieldsValue(newCamera);
  };

  const onRefreshTimezone = () => {
    const payload = {
      lat: camera.latitude,
      lon: camera.longitude,
    };
    const params = JSON.stringify(payload);
    setLoading(true);
    Api.MAP_REFRESH_TIMEZONE(params).then(((res: any) => {
      setLoading(false);
      if (res.statusCode == 200) {
        const newCamera = {
          ...camera,
          timezone: res.text,
        };
        console.log('timezone', newCamera);
        setCamera(newCamera);
        form.setFieldsValue(newCamera);
      } else {
        notification.open({
          message: 'Something went wrong!',
        });
      }
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  return (
    <>
      <Row>
        {md && (
          <Col md={12} className={classes.leftMap} style={{ height: '80vh' }}>
            <CameraAddMap camera={camera} onDragEnd={onDragEnd} zoom={14} cameras={cameras} />
          </Col>
        )}
        <Col md={12} xs={24}>
          <div className={classes.content} style={{ padding: md ? 24 : 16 }}>
            <Spin spinning={loading} size="large">
              <Card title="Camera" bodyStyle={{ padding: '8px' }}>
                <Form
                  {...layout}
                  form={form}
                  name="basic"
                  onValuesChange={onValuesChange}
                  onFinish={onFinish}
                >
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: 'Please input camera name',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Divider />
                  <p>
                    You can use the search bar at the top of the map to set the location of the camera.<br />
                    You can also drag the pin on the map to the correct location.<br />
                    Lastly, you can also use the Move Near Camera feature to move the new camera to the same location as one of your existing cameras.
                  </p>
                  <Form.Item
                    label="Latitude"
                    name="latitude"
                    rules={[
                      {
                        required: true,
                        message: 'Latitude',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                  <Form.Item
                    label="Longitude"
                    name="longitude"
                    rules={[
                      {
                        required: true,
                        message: 'Longitude',
                      },
                    ]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    label="Timezone"
                    name="timezone"
                    style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}
                  >
                    <Select size="large" style={{ width: '90%' }} value={camera.timezone} onChange={(value) => setCamera({ ...camera, timezone: value })}>
                      {timezones.map((val: any, i) => (
                        <Select.Option key={i} value={val}>
                          {val}
                        </Select.Option>
                      ))}
                    </Select>
                    <Button
                      type="primary"
                      onClick={onRefreshTimezone}
                      style={{ margin: '5px', borderRadius: '50%' }}
                      icon={<ReloadOutlined />}
                    />
                  </Form.Item>

                  {
                    cameras.length > 0 && (
                      <Form.Item
                        label="Move Near Camera"
                      >
                        <Select
                          size="large"
                          className={classes.select}
                          onChange={changeCamera}
                        >
                          {cameras.map((val: any, i) => (
                            <Select.Option key={val.id} value={i}>{val.name}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    )
                  }
                  <Form.Item
                    label="Fixed Location"
                    name="fix_location"
                  >
                    <Switch checked={camera.fix_location == 1} onChange={onChangeFixLocation} />
                  </Form.Item>
                  <Row>
                    <Col offset={6}>
                      <Form.Item {...buttonLayout}>
                        {profile.account_type != 'pro_manager' && profile.account_type != 'pro_user' && (
                          <Button type="ghost" onClick={deleteItem}>
                            Delete
                          </Button>
                        )}
                      </Form.Item>
                    </Col>
                    <Col offset={1} span={6}>
                      <Form.Item {...buttonLayout}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>

                  {
                    camera.IMEI != '' && (
                      <>
                      </>
                    )
                  }
                </Form>
              </Card>
            </Spin>
            {
              camera.IMEI != '' && (
                <Card
                  title="Activate"
                  bodyStyle={{ padding: '8px' }}
                  style={{ marginTop: '20px' }}
                >
                  <Form
                    {...layout}
                    name="basic"
                  >
                    <p style={{ margin: '16px' }} className="text-muted">Activating/Deactivating your cameras does not automatically remove them from your subscription. Please visit <a href="https://wiseeyetech.com/my-account/">My Account</a> if you wish to increase/reduce the number of cams in your subscription.</p>
                    <Form.Item
                      label="Activate"
                      name="activate"
                    >
                      <Switch checked={camera.is_active == 1} onChange={onChangeActivate} />
                    </Form.Item>
                  </Form>
                </Card>
              )
            }
            {
              camera.IMEI != '' && (
                <Card
                  title="Archive"
                  bodyStyle={{ padding: '8px' }}
                  style={{ marginTop: '20px' }}
                  extra={(
                    <Popconfirm title="Are you sure to archive this camera?" onConfirm={onArchive}>
                      <Button type="ghost" className={classes.editTrash}>
                        Archive
                      </Button>
                    </Popconfirm>
                  )}
                >
                  <Form
                    {...layout}
                    name="basic"
                  >
                    <p style={{ margin: '16px' }} className="text-muted">By Clicking the Archive button you will freeze the data and images for this location and be allowed to use the IMEI number in a new location. This is useful if you want to move the camera to a new site and don’t want the old images and data to be affected by the move.</p>
                  </Form>
                </Card>
              )
            }
            {
              camera.IMEI == '' && (
                <Card
                  title="Assign"
                  bodyStyle={{ padding: '8px' }}
                  style={{ marginTop: '20px' }}
                >
                  <Form
                    {...layout}
                    form={form2}
                    name="basic"
                    onFinish={onFinishAssign}
                  >
                    {
                      camera.IMEI_suspended != '' && (
                        <Form.Item
                          label="Old IMEI"
                          rules={[
                            {
                              required: true,
                              message: 'Please input IMEI',
                            },
                          ]}
                        >
                          <Input value={camera.IMEI_suspended} disabled />
                        </Form.Item>
                      )
                    }
                    <Form.Item
                      label="IMEI"
                      name="IMEI"
                      rules={[
                        {
                          required: true,
                          message: 'Please input IMEI',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Row>
                      <Col offset={6}>
                        <Form.Item {...buttonLayout}>
                          <Button type="primary" htmlType="submit">
                            Assign
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              )
            }
            <Card
              title="Recently Uploaded Images"
              extra={(
                <Popconfirm title="Are you sure to move all images of this camera to the trash folder?" onConfirm={onTrashAll}>
                  <Button type="ghost" className={classes.editTrash}>
                    Trash All
                  </Button>
                </Popconfirm>
              )}
              bodyStyle={{ padding: '8px' }}
              style={{ marginTop: '20px' }}
            >
              <Spin spinning={loadingRecently} size="large">
                <Carousel
                  autoplay
                  dotPosition="top"
                >
                  {images.map((e, i) => (
                    <DashboardImageCard key={i} detail={e} />
                  ))}
                </Carousel>
              </Spin>
            </Card>
            {md == false && (
              <Col xs={24} md={24} style={{ height: '400px' }}>
                <CameraAddMap camera={camera} onDragEnd={onDragEnd} zoom={14} cameras={cameras} />
              </Col>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CameraEdit;
